import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useClassName } from 'common/hooks';
import { Link } from 'react-router-dom';
import { SVGIcon as Icon, DesktopOnly, MobileOnly } from 'common/components';
import './styles/breadcrumb.less';

const Breadcrumb = ({ type, event }) => {
  const classNames = useClassName('EventsBreadcrumbs');

  const links = [{ url: '/events/category', title: 'Events' }];

  if (type?.slug && type?.name) {
    links.push({ url: `/venue/${type.slug}`, title: type.name });
  }

  if (event?.title) {
    links.push({ url: window.location.pathname, title: event.title });
  }

  return (
    <>
      <DesktopOnly className={classNames('container')}>
        <Link to="/">
          <Icon name="home" size="tiny" className="home" />
        </Link>
        {links.map((link, index) => (
          <Fragment key={index}>
            <Icon
              name="chevron-right-white"
              size="tiny"
              className={classNames('chevron')}
            />
            <Link to={link.url}>{link.title}</Link>
          </Fragment>
        ))}
      </DesktopOnly>

      <MobileOnly className={classNames('container')}>
        <Link to={links[0].url}>
          <Icon name="arrow-left" size="mini" />
          {links[0].title}
        </Link>
      </MobileOnly>
    </>
  );
};

Breadcrumb.propTypes = {
  type: PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string,
  }),
  event: PropTypes.shape({
    title: PropTypes.string,
  }),
};

export default Breadcrumb;
